import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetGotoPreference = (mealTime: MealTime) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKeys.GO_TO_PREFERENCE, mealTime],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.getGotoPreferencesForMealTimeApiV1MealsGotoPreferencesMealTimeGet(
          mealTime,
          user.id,
        );
      return data;
    },
  });

  return {
    gotoPreference: data,
    isLoading: isLoading,
    isError: isError,
  };
};
